module.exports = __webpack_public_path__ + "img/245.52780ae7.jpg";